/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHexagonalPrism = createReactComponent("hexagonal-prism", "IconHexagonalPrism", [
  [
    "path",
    {
      d: "M20.792 6.996l-3.775 2.643a2.005 2.005 0 0 1 -1.147 .361h-7.74c-.41 0 -.81 -.126 -1.146 -.362l-3.774 -2.641",
      key: "svg-0"
    }
  ],
  ["path", { d: "M8 10v11", key: "svg-1" }],
  ["path", { d: "M16 10v11", key: "svg-2" }],
  [
    "path",
    {
      d: "M3.853 18.274l3.367 2.363a2 2 0 0 0 1.147 .363h7.265c.41 0 .811 -.126 1.147 -.363l3.367 -2.363c.536 -.375 .854 -.99 .854 -1.643v-9.262c0 -.655 -.318 -1.268 -.853 -1.643l-3.367 -2.363a2 2 0 0 0 -1.147 -.363h-7.266c-.41 0 -.811 .126 -1.147 .363l-3.367 2.363a2.006 2.006 0 0 0 -.853 1.644v9.261c0 .655 .318 1.269 .853 1.644z",
      key: "svg-3"
    }
  ]
]);

export { IconHexagonalPrism as default };
//# sourceMappingURL=IconHexagonalPrism.js.map
